<template>
  <div class="asc-plot-overlay--container">
    <asc-switch v-model="overlayStatus" :label="title"></asc-switch>
  </div>
</template>

<script>
import AscSwitch from '@/components/atoms/AscSwitch'

export default {
  name: 'AscPlotOverlay',

  components: { AscSwitch },

  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    status: {
      type: Boolean,
      default: false,
    },
    onUpdate: {
      type: Function,
      required: true,
    },
  },

  data: function () {
    return {
      overlayStatus: this.status,
    }
  },

  watch: {
    overlayStatus(newValue) {
      this.$emit('update:value', newValue)
      this.$emit('input', newValue)
      this.onUpdate(this.overlayStatus)
    },
  },
}
</script>

<style lang="scss">
.asc-plot-overlay {
  &--container {
    padding: 8px 16px;
    min-width: 112px;
    min-height: 60px;

    .asc-switch {
      .asc-label {
        font-size: 14px;
        line-height: 18px;
      }
    }
  }
}
</style>
